<template>
  <div id="InstitutionsView" class="page">
    <BaseBreadcrumb :items="breadcrumbItems" />
    <div class="page-list">
      <BContainer>
        <InstitutionList />
      </BContainer>
    </div>
  </div>
</template>

<script>
import InstitutionList from "../components/Institution/InstitutionList.vue";

export default {
  name: "InstitutionsView",
  components: {
    InstitutionList
  },
  data() {
    return {
      institutions: [],
      breadcrumbItems: [
        {
          text: "Home",
          link: "/"
        },
        {
          text: "Especialistas e Clínicas"
        }
      ]
    };
  }
};
</script>
